import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { IconComponent, CobaltButtonModule, CobaltSpinnerModule } from '@msi/cobalt-prime';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuggestMatchResult } from '@geocode-models/suggest-match-result.model';
import { SuggestControlComponent } from '../../suggest-control/suggest-control.component';

export type AddressSuggestDialogResult =
  | { action: 'validate'; address: SuggestMatchResult }
  | { action: 'advancedSearch' }
  | null;

@Component({
  selector: 'app-address-suggest-dialog',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, TranslocoPipe, IconComponent, CobaltButtonModule, CobaltSpinnerModule, SuggestControlComponent],
  templateUrl: './address-suggest-dialog.component.html',
})
export class AddressSuggestDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  protected readonly config = inject(DynamicDialogConfig);

  public processing = false;
  public validAddress = false;
  public suggestedAddress?: SuggestMatchResult;

  public onSuggestAddressSelected(result: SuggestMatchResult | null): void {
    if (!result) {
      this.validAddress = false;
      this.suggestedAddress = undefined;
      return;
    }
    this.validAddress = true;
    this.suggestedAddress = result;
  }

  public onValidate(): void {
    if (!this.validAddress || !this.suggestedAddress) {
      return;
    }
    this.dialogRef.close({ action: 'validate', address: this.suggestedAddress } satisfies AddressSuggestDialogResult);
  }

  public onAdvancedSearch(): void {
    this.dialogRef.close({ action: 'advancedSearch' } satisfies AddressSuggestDialogResult);
  }

  public onCancel(): void {
    this.dialogRef.close(null);
  }
}
